import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";

// Confirms a placement is still employed past its backfill guarantee.
export function useUpdateSetPlacementMadeIt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ placementId }: { placementId: number }) => {
      await guacHttpClient.patch(
        `staffer-earnings/placements/${placementId.toString()}/made-it`,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["staffer-earnings"] });
    },
  });
}
